import { render, staticRenderFns } from "./CarrierBillingChargeStats.vue?vue&type=template&id=12e3a8fe"
import script from "./CarrierBillingChargeStats.vue?vue&type=script&lang=js"
export * from "./CarrierBillingChargeStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports